import React, { useEffect, useState, useMemo } from 'react';
import { getdata, updatedata, getdate, formatdate } from "../../util/global";


const MEDICINEDATA = [{medicine:"paracetamol",dosage:"",instructions:""}, 
  {medicine:"amoxicillin",dosage:"",instructions:""},
  {medicine:"ibuprofen",dosage:"",instructions:""},
  {medicine:"metformin",dosage:"",instructions:""},
  {medicine:"atorvastatin",dosage:"",instructions:""}];
const PrescriptionForm = ({ mode, setmode, formdata, setformdata, handlesubmit, patientdata, prescriptiondata }) => {
  const [activefield, setactivefield] = useState(null); 
  const [suggestions, setsuggestions] = useState([]);

  const handleautocomplete = (field, value, data, key, index= null) => {

    if (index !== null) {
      const newrows = [...formdata.medicinedata];
      newrows[index][field] = value;
      setformdata({ ...formdata, medicinedata: newrows });
    } else {
      setformdata({ ...formdata, [field]: value });
    }

    if (key == "medicine") {
      data = data.concat(MEDICINEDATA);
    }

    let dupmap = [];
    let matches = [];
    data.filter(item => {
      if (!item) return;
      let val = item[key];
      let dupval = dupmap[val];
      if (dupval) return false;
      dupmap[val] = val;
      if (item[key].toLowerCase().includes(value.toLowerCase())) {
        matches.push(item[key]);
      }
    });
    setsuggestions(matches);
    field = field + (index !== null ? "-" + index :"");
    setactivefield(field);
  };

  const selectoption = (field, value, index) => {
    if (field === 'name') {
      const phone = patientdata.find(item => item.name.trim() == value);
      let lastprescription = prescriptiondata.find(item => {
        return item._patientid == phone._id;
      });
      for (let i=0; lastprescription && i < lastprescription.medicinedata?.length;i++) {
        addrow();
      }
      setformdata({ ...formdata, name: value, phonenumber: phone?.phonenumber || formdata.phone , 
        medicinedata: lastprescription?.medicinedata || formdata.medicinedata});
      
    } else if (field == "phonenumber") {
      setformdata({ ...formdata, phonenumber: value });
    } else if (field.includes("medicine")) {
      let medicine = medicinedata.find(item => item && item.medicine.trim().includes(value));
      let medicinerow = {medicine: value, dosage:medicine?.dosage || formdata.dosage, instructions:medicine?.instructions || formdata.instructions };
      formdata.medicinedata[index] = medicinerow;
      //setformdata({ ...formdata, medicine: value, dosage:medicine?.dosage || formdata.dosage, instructions:medicine?.instructions || formdata.instructions });
    }
    setactivefield(null);
  };

  const addrow = () => {
    const newrows = [...(formdata.medicinedata || []), { medicine: "", dosage: "", instructions: "" }];
    setformdata({ ...formdata, medicinedata: newrows });
  };

  const deleterow = (index) => {
    const newrows = formdata.medicinedata.filter((_, i) => i !== index);
    setformdata({ ...formdata, medicinedata: newrows });
  };
     
  let medicinedata = [];
  for (let i=0; i < prescriptiondata.length;i++) {
    medicinedata = medicinedata.concat(prescriptiondata[i].medicinedata);
  }
  useEffect(() => { 
    console.log("FORM USE EFFECT");
    $( ".date" ).datepicker({
      changeMonth: true,
      changeYear: true,
      showButtonPanel: true,
      yearRange: "0:+50",
      dateFormat: "M dd yy",
      minDate : 0,
      onSelect: (datetext) => {
        const date = getdate(datetext).datestr;
        setformdata(prev => ({
          ...prev, 
          datetime: datetext,
          date: date
        }));
      }
    });
  }, [mode]);
  if (mode != "editprescription") return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata._id ? "edit prescription" : "new prescription"}</h3>
          <button className="close-btn" onClick={() => setmode("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group" style={{ position: 'relative'}}>
            <label>date</label>
            <input type="text" className="form-input date" value={formdata.datetime} id="datetime"
                onChange={(e) => {formdata.datetime = e.target.value; }}
            />
          </div>
          <div className="form-group" style={{ position: 'relative' }}>
            <label>Patient Name</label>
            <input 
              type="text" className="form-input" value={formdata.name}
              onChange={(e) => handleautocomplete('name', e.target.value, patientdata, 'name')}
              onFocus={(e) => handleautocomplete('name', e.target.value, patientdata, 'name')}
              onBlur={() => setTimeout(() => setactivefield(null), 200)}
            />
            {activefield === 'name' && (
              <div className="autocomplete-dropdown">{suggestions.map(s => (
                <div key={s} onMouseDown={() => selectoption('name', s)} style={{ padding: '10px', cursor: 'pointer' }}>{s}</div>
              ))}</div>
            )}
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input type="text" className="form-input" value={formdata.phonenumber} 
              onChange={(e) => handleautocomplete('phonenumber', e.target.value, patientdata.filter(item => item.name.trim().includes(formdata.name)), 'phonenumber')}
              onFocus={(e) => handleautocomplete('phonenumber', e.target.value, patientdata.filter(item => item.name.trim().includes(formdata.name)), 'phonenumber')}
            />
            {activefield === 'phonenumber' && (
              <div className="autocomplete-dropdown">{suggestions.map(s => (
                <div key={s} onMouseDown={() => selectoption('phonenumber', s)} style={{ padding: '10px', cursor: 'pointer' }}>{s}</div>
              ))}</div>
            )}
          </div>

          {/* medicine table section */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <label style={{ fontWeight: 'bold' }}>medicines</label>
            <button className="btn-blue" onClick={addrow} style={{ padding: '5px 15px', fontSize: '12px' }}>+ add row</button>
          </div>

          <table className="grid" style={{ width: '100%', marginBottom: '20px' }}>
            <thead>
              <tr>
                <th style={{ width: '30%' }}>medicine</th>
                <th style={{ width: '20%' }}>dosage</th>
                <th style={{ width: '40%' }}>instructions</th>
                <th style={{ width: '50px' }}></th>
              </tr>
            </thead>
            <tbody>
              {formdata.medicinedata?.map((row, index) => (
                <tr key={index}>
                  
                  <td style={{
                    position: 'relative', 
                    padding: '5px', 
                   }}>
                    <input 
                      type="text" className="form-input" placeholder="medicine" value={row.medicine}
                      onChange={(e) => handleautocomplete('medicine', e.target.value, medicinedata, 'medicine', index)}
                      onFocus={(e) => handleautocomplete('medicine', e.target.value, medicinedata, 'medicine', index)}
                      onBlur={() => setTimeout(() => setactivefield(null), 200)}
                    />
                   {activefield === `medicine-${index}` && (
                    <div className="autocomplete-dropdown">{suggestions.map(s => (
                      <div key={s} onMouseDown={() => selectoption(`medicine-${index}`, s, index)} style={{ padding: '10px', cursor: 'pointer' }}>{s}</div>
                    ))}
                    </div>
                  )}
                  </td>

                  <td style={{ position: 'relative', padding: '5px' }}>
                    <input 
                      type="text" className="form-input" placeholder="dosage" value={row.dosage}
                      onChange={(e) => handleautocomplete('dosage', e.target.value, medicinedata, 'dosage', index)}
                      onFocus={(e) => handleautocomplete('dosage', e.target.value, medicinedata, 'dosage', index)}
                      onBlur={() => setTimeout(() => setactivefield(null), 200)}
                    />
                    {activefield === `dosage-${index}` && (
                      <div className="autocomplete-dropdown" style={{ position: 'absolute', width: '100%', zIndex: 100 }}>
                        {suggestions.map((s, i) => (
                          <div key={i} onMouseDown={() => selectoption('dosage', s, index)} style={{position:'absolute', padding: '8px', cursor: 'pointer' }}>{s}</div>
                        ))}
                      </div>
                    )}
                  </td>
                  <td style={{ position: 'relative', padding: '5px' }}>
                    <input 
                      type="text" className="form-input" placeholder="instructions" value={row.instructions}
                      onChange={(e) => handleautocomplete('instructions', e.target.value, medicinedata, 'instructions', index)}
                      onFocus={(e) => handleautocomplete('instructions', e.target.value, medicinedata, 'instructions', index)}
                      onBlur={() => setTimeout(() => setactivefield(null), 200)}
                    />
                    {activefield === `instructions-${index}` && (
                      <div className="autocomplete-dropdown" style={{ position: 'absolute', width: '100%', zIndex: 100 }}>
                        {suggestions.map((s, i) => (
                          <div key={i} onMouseDown={() => selectoption('instructions', s, index)} style={{ padding: '8px', cursor: 'pointer' }}>{s}</div>
                        ))}
                      </div>
                    )}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <button onClick={() => deleterow(index)} style={{ background: 'none', border: 'none', color: '#ff4d4f', cursor: 'pointer', fontSize: '18px' }}>&times;</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="form-group">
            <label>notes</label>
            <textarea
              style={{height:'100px'}}
              className="form-input"
              rows={8}
              placeholder="Additional notes for this prescription — optional"
              value={formdata.notes || ""}
              onChange={(e) => setformdata({ ...formdata, notes: e.target.value })}
            />
          </div>
          <button className="btn-blue full-width" onClick={handlesubmit}>save prescription</button>
        </div>
      </div>
    </div>
  );
};

export default PrescriptionForm;